module.exports = __webpack_public_path__ + "img/truck-check.db794cfe.svg";